/**
 * Intelligems mega menu A/B/C test – syncs aria + drawer class.
 * Visibility is controlled by body class in mega-menu-test.css.
 * Remove this asset when the test ends.
 */
(function () {
  const CLASS_MAP = {
    a: 'ig-mega-menu-a',
    b: 'ig-mega-menu-b',
    c: 'ig-mega-menu-c',
  };

  const DEFAULT = 'a';

  function detectVariant() {
    const body = document.body;
    if (!body) return DEFAULT;

    if (body.classList.contains(CLASS_MAP.c)) return 'c';
    if (body.classList.contains(CLASS_MAP.b)) return 'b';
    if (body.classList.contains(CLASS_MAP.a)) return 'a';

    return DEFAULT;
  }

  function sync() {
    const variant = detectVariant();
    const root = document.querySelector('[data-mega-menu-test]');
    const menuDrawer = document.getElementById('menu-drawer');

    if (root) {
      root.querySelectorAll('[data-mega-menu-variant]').forEach((node) => {
        const nodeVariant = node.getAttribute('data-mega-menu-variant');
        const isActive = nodeVariant === variant;
        node.classList.toggle('is-active', isActive);
        node.classList.toggle('is-hidden', !isActive);
        node.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      root.classList.remove('mega-menu-test--variant-a', 'mega-menu-test--variant-b', 'mega-menu-test--variant-c');
      root.classList.add('mega-menu-test--ready', 'mega-menu-test--variant-' + variant);
    }

    if (menuDrawer) {
      menuDrawer.classList.toggle('menu-drawer--promo', variant === 'b' || variant === 'c');
    }
  }

  function observeBody() {
    if (!document.body) return;

    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function init() {
    observeBody();
    sync();

    let pollCount = 0;
    const pollId = window.setInterval(function () {
      sync();
      pollCount += 1;
      if (pollCount >= 60) {
        window.clearInterval(pollId);
      }
    }, 500);

    document.addEventListener('shopify:section:load', sync);
    window.addEventListener('pageshow', sync);
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
